import { useEffect } from 'react'

import { useLocation } from 'react-router'

import { hitParametersUrl } from 'common/constants'

/**
 * Для удаление hitId query params
 * чтобы при перезагрузке лишний раз не дергать
 * запрос на профиль с параметром hitId
 */
export const useHitQueryRemoveParams = () => {
  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const hitId = searchParams.get(hitParametersUrl)

  useEffect(() => {
    if (hitId) {
      searchParams.delete(hitId)
      const newURL = location.href.split('?')[0]
      window.history.replaceState('object', document.title, newURL)
    }
  }, [hitId, searchParams])
}
